export default "__VITE_ASSET__DkWkv4F8__"